<script setup>
import { Link } from '@inertiajs/vue3'
import UiButton from '@/Components/UI/UiButton.vue'

defineProps({
  type:    { type: String, default: 'filter' }, // 'first-use' | 'filter' | 'period' | 'success'
  title:   { type: String, required: true },
  message: { type: String, default: '' },
  cta:     { type: String, default: '' },       // label for action button
  ctaHref: { type: String, default: '' },       // if set, renders as link
})
defineEmits(['cta-click', 'clear'])
</script>

<template>
  <div class="flex flex-col items-center justify-center py-16 px-4 text-center">
    <!-- Success check for "all on track" -->
    <div v-if="type === 'success'" class="w-14 h-14 rounded-full flex items-center justify-center mb-4" :style="{ background: 'var(--okSoft)' }">
      <svg class="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" :style="{ color: 'var(--ok)' }">
        <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7"/>
      </svg>
    </div>
    <!-- Folder icon for first-use -->
    <div v-else-if="type === 'first-use'" class="w-14 h-14 rounded-full flex items-center justify-center mb-4" :style="{ background: 'var(--accentSoft)' }">
      <svg class="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5" :style="{ color: 'var(--accent)' }">
        <path stroke-linecap="round" stroke-linejoin="round" d="M3 7a2 2 0 012-2h4l2 2h8a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V7z"/>
      </svg>
    </div>
    <!-- Search icon for filter empty -->
    <div v-else class="w-14 h-14 rounded-full flex items-center justify-center mb-4" :style="{ background: 'var(--surfaceAlt)' }">
      <svg class="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5" :style="{ color: 'var(--muted)' }">
        <circle cx="11" cy="11" r="8"/><path stroke-linecap="round" d="m21 21-4.35-4.35"/>
      </svg>
    </div>

    <p class="text-base font-semibold mb-1 text-[color:var(--ink)]">{{ title }}</p>
    <p v-if="message" class="text-sm text-[color:var(--muted)] max-w-xs">{{ message }}</p>

    <div v-if="cta" class="mt-4">
      <Link v-if="ctaHref" :href="ctaHref">
        <UiButton variant="primary">{{ cta }}</UiButton>
      </Link>
      <UiButton v-else variant="primary" @click="$emit('cta-click')">
        {{ cta }}
      </UiButton>
    </div>
    <button
      v-if="type === 'filter'"
      type="button"
      class="mt-3 text-sm text-[color:var(--accent)] hover:underline"
      @click="$emit('clear')"
    >
      Clear filters
    </button>
  </div>
</template>
